import { Logger } from './logger';

export const AUTH_TYPE = {
  LOGIN: 'login' as const,
  SIGNUP: 'signup' as const,
};

export type AuthType = typeof AUTH_TYPE.LOGIN | typeof AUTH_TYPE.SIGNUP;

const isUserLoggedIn = () => {
  return window.localStorage.getItem('userLoggedIn') != null;
};

const usersLoggedInType = (): AuthType | null => {
  const type = window.localStorage.getItem('userLoggedIn');
  return type as AuthType | null;
};

const markUserLoggedIn = (type: AuthType) => {
  window.localStorage.setItem('userLoggedIn', type);
  Logger.log('User logged in');
};

const markUserLoggedOut = () => {
  window.localStorage.removeItem('userLoggedIn');
  window.localStorage.removeItem('cmsContext');
};

export {
  isUserLoggedIn,
  markUserLoggedIn,
  markUserLoggedOut,
  usersLoggedInType,
};
